module.exports = __webpack_public_path__ + "media/images/soar/site/woman_02-ac25fbcf85fbe873302c80a06d57c25f.svg";